import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { MENU_ITEMS } from '@app/shared/navigation-bar/menu-items';
import { signal } from '@angular/core';
import { computed } from '@angular/core';

export interface LayoutState {
  heroBg: string;
  customStyles: { [p: string]: any } | null;
  heroOverlay?: string;
  showMobileMenu: boolean;
}

export const initialState: LayoutState = {
  heroBg: '',
  customStyles: null,
  heroOverlay: undefined,
  showMobileMenu: false,
};

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private state = signal<LayoutState>(initialState);

  constructor() {}

  menuItems = MENU_ITEMS;

  showMobileMenu = computed<boolean>(() => {
    return this.state().showMobileMenu;
  });

  setBgImage(url: string): void {
    this.state.set({ ...this.state(), heroBg: url });
  }

  showMenu(showMobileMenu: boolean) {
    this.state.update((state: LayoutState) => ({ ...state, showMobileMenu }));
  }
}
